import React, { forwardRef, useImperativeHandle } from "react";
import initial from "../assets/initial.png";
import Stone from "../assets/Stone.png";
import Paper from "../assets/Paper.png";
import Scissor from "../assets/Scissor.png";

const ComputerFeed = forwardRef((prop, ref) => {
  let compFeed = (e) => {
    let imgSrc =
      prop.random === 1 ? Stone : prop.random === 2 ? Paper : Scissor;
    let newComImg = document.querySelector(`.${e.target.className}`);
    newComImg.innerHTML = `<img
    src=${imgSrc}
    alt="initial"
    style="width:100%;transform:scaleX(-1)" />`;
  };

  useImperativeHandle(ref, () => ({
    callAnime() {
      var anime = document.getElementById("ImgComp");
      anime.classList.remove("initial-hand");
      anime.children[0].src = initial;
      void anime.offsetWidth;
      anime.classList.add("initial-hand");
    },
  }));

  return (
    <React.Fragment>
      <div className="initial-hand" id="ImgComp" onAnimationEnd={compFeed}>
        <img
          src={initial}
          alt="initial"
          style={{ width: "100%", transform: "scaleX(-1)" }}
        />
      </div>
    </React.Fragment>
  );
});

export default ComputerFeed;
